/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CloneCreditApplication_cloneCreditApplication_CloneCreditApplicationResponse = { readonly __typename: 'CloneCreditApplicationResponse', readonly salesforceCreditId: string, readonly token: string };

export type CloneCreditApplication_Mutation = { readonly __typename: 'Mutation', readonly cloneCreditApplication: CloneCreditApplication_cloneCreditApplication_CloneCreditApplicationResponse };


export type CloneCreditApplicationVariables = _Types.Exact<{
  salesforceCreditId: _Types.Scalars['ID']['input'];
}>;


export type CloneCreditApplication = CloneCreditApplication_Mutation;


export const CloneCreditApplicationDocument = gql`
    mutation CloneCreditApplication($salesforceCreditId: ID!) {
  cloneCreditApplication(salesforceCreditId: $salesforceCreditId) {
    salesforceCreditId
    token
  }
}
    `;
export type CloneCreditApplicationMutationFn = Apollo.MutationFunction<CloneCreditApplication, CloneCreditApplicationVariables>;

/**
 * __useCloneCreditApplication__
 *
 * To run a mutation, you first call `useCloneCreditApplication` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneCreditApplication` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneCreditApplication, { data, loading, error }] = useCloneCreditApplication({
 *   variables: {
 *      salesforceCreditId: // value for 'salesforceCreditId'
 *   },
 * });
 */
export function useCloneCreditApplication(baseOptions?: Apollo.MutationHookOptions<CloneCreditApplication, CloneCreditApplicationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneCreditApplication, CloneCreditApplicationVariables>(CloneCreditApplicationDocument, options);
      }
export type CloneCreditApplicationHookResult = ReturnType<typeof useCloneCreditApplication>;
export type CloneCreditApplicationMutationResult = Apollo.MutationResult<CloneCreditApplication>;
export type CloneCreditApplicationMutationOptions = Apollo.BaseMutationOptions<CloneCreditApplication, CloneCreditApplicationVariables>;